// extracted by mini-css-extract-plugin
export var image = "LazyImage-module--image--628e2";
export var loaded = "LazyImage-module--loaded--38171";